export const extensionToMimeTypeMap: Map<string, string> = new Map<
  string,
  string
>([
  ['bmp', 'image/bmp'],
  ['csv', 'text/csv'],
  ['doc', 'application/msword'],
  ['docm', 'application/vnd.ms-word.document.macroEnabled.12'],
  [
    'docx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  ['exe', 'application/x-msdownload'],
  ['gif', 'image/gif'],
  ['htm', 'text/html'],
  ['html', 'text/html'],
  ['jpe', 'image/jpeg'],
  ['jpeg', 'image/jpeg'],
  ['jpg', 'image/jpeg'],
  ['mid', 'audio/midi'],
  ['mp3', 'audio/mpeg'],
  ['mpeg', 'video/mpeg'],
  ['pdf', 'application/pdf'],
  ['png', 'image/png'],
  ['ppt', 'application/vnd.ms-powerpoint'],
  ['pptm', 'application/vnd.ms-powerpoint.presentation.macroEnabled.12'],
  [
    'pptx',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ],
  ['ram', 'audio/x-pn-realaudio'],
  ['tif', 'image/tif'],
  ['tiff', 'image/tiff'],
  ['txt', 'text/plain'],
  ['wav', 'audio/x-wav'],
  ['xls', 'application/vnd.ms-excel'],
  ['xlsm', 'application/vnd.ms-excel.sheet.macroEnabled.12'],
  ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  ['xml', 'text/xml'],
  ['xsl', 'text/xml'],
  ['zip', 'application/x-zip-compressed'],
]);
